import React from 'react';
import PropTypes from 'prop-types';
import formatCurrency from '../../../utils/formatCurrency';
import styles from './PropertySummary.scss';

const nisSign = '₪';

function formatPrice(price, isRtl, searchOption, translate, currency) {
  const currencySymbol = currency ? formatCurrency(currency) : nisSign;
  const currencySign = (price) ? currencySymbol : '';
  if (searchOption === 'forShortRent') {
    return isRtl
      ? <span>{`${price} ${currencySign}/${translate('day')}`}</span>
      : <span>{`${translate('day')}/${currencySign} ${price}`}</span>;
  }
  return isRtl
    ? (<span>{ price } {currencySign}</span>)
    : (<span>{currencySign} { price }</span>);
}

const PropertySummary = ({
  translate,
  data: { price,
    currency,
    pricePerSqMeter,
    address: { cityName, streetName, houseNumber, countryName, neighborhood },
    additionalInfo,
    isCottage,
    isForeign
  },
  className,
  isRtl,
  isMobile,
  searchOption
}) => {
  const currencySymbol = currency ? formatCurrency(currency) : nisSign;
  return (
    <div className={className}>
      <div className={styles.priceLine}>
        { formatPrice(price, isRtl, searchOption, translate, currency) }&nbsp;&nbsp;
        {isMobile && (<br />)}
        { !!pricePerSqMeter && <span className={styles.pricePerSqM}>{pricePerSqMeter}&nbsp;{currencySymbol}{translate('perSqMeter')}</span>}
      </div>

      <h1 className={styles.addressLine}>
        { (cityName) ? (
          <div>
            <p className={styles.streetName}>{streetName} {houseNumber}</p>
            <div className={styles.neighborhood}>
              {neighborhood && (neighborhood !== cityName) && <div>{neighborhood}, &nbsp;</div>}
              <div>{cityName}{isForeign && `, ${countryName}`}</div>
            </div>
          </div>
        ) : '' }
      </h1>

      <div className={styles.iconsGroup}>
        { additionalInfo && additionalInfo.rooms ? (
          <div>
            <span className="icon icon-door" />
            <span property="numberOfRooms" className={styles.iconsText}>
            {translate('rooms')}: {additionalInfo.rooms}
          </span>
          </div>
        ) : null }

        { additionalInfo && additionalInfo.floor ? (
          <div>
            <span className="icon icon-floor" />
            <span className={styles.iconsText}>
            {translate('details', `${isCottage ? 'floors' : 'floor'}`)} {additionalInfo.floor}
          </span>
          </div>
        ) : null }

        {/* <div>
       <span className="icon icon-bath" />
       <span className={styles.iconsText}>`${additionalInfo.toilets} ${translate('toilets')}`</span>
       </div> */}

        { additionalInfo && additionalInfo.area ? (
          <div>
            <span className="icon icon-square" />
            <span className={styles.iconsText}>
            {`${translate('square')}: ${additionalInfo.area}`}
          </span>
          </div>
        ) : null }

        { additionalInfo && additionalInfo.parkingSpots ? (
          <div>
            <span className="icon icon-parkingSpot" />
            <span className={styles.iconsText}>
            {additionalInfo.parkingSpots === 1
              ? translate('parkingSpot') : translate('parkingSpots')}
              : {additionalInfo.parkingSpots}
          </span>
          </div>
        ) : null }
      </div>
    </div>
  );
};

PropertySummary.propTypes = {
  translate: PropTypes.func,
  data: PropTypes.object,
  className: PropTypes.string,
  isRtl: PropTypes.bool,
  isMobile: PropTypes.bool,
  searchOption: PropTypes.string,
  isForeign: PropTypes.bool
};

export default PropertySummary;
